export default {
  "content": "<path d=\"M17.304 6.641A4.597 4.597 0 0013.25 4.25H.436c-.247 0-.436.2-.436.444 0 .114.044.229.13.3l2.79 2.764c.247.243.581.387.93.387h9.037c.64 0 1.177.5 1.177 1.13 0 .63-.508 1.16-1.148 1.16H6.683c-.247 0-.436.2-.436.444 0 .115.044.23.131.301l2.775 2.763c.247.244.581.387.93.387h2.819c3.676 0 6.45-3.866 4.402-7.689z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "18",
    "height": "19",
    "viewBox": "0 0 18 19",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};